import { t } from "../../i18n";
import "./seo.scss";

export const SERP_TITLE_LIMIT = 60;
export const SERP_DESCRIPTION_LIMIT = 160;

export interface SerpPreviewProps {
  /** The page address as a search result shows it, e.g. "example.com › casino". */
  displayUrl: string;
  title?: string;
  description?: string;
  testId?: string;
}

/** Cuts text where a search result would, marking the cut with an ellipsis. */
export function truncateForSerp(text: string, limit: number): string {
  if (text.length <= limit) {
    return text;
  }
  return `${text.slice(0, limit).trimEnd()}…`;
}

/**
 * An approximation of how a search engine lists the page. The limits are character counts, while
 * the engine cuts by pixel width, so the preview can differ from a real result by a few characters.
 */
export function SerpPreview({ displayUrl, title, description, testId = "serp-preview" }: SerpPreviewProps): JSX.Element {
  return (
    <div data-testid={testId}>
      <div className="seo-serp-preview__label">{t("admin.seo.serp-preview", undefined, "Search result preview")}</div>
      <div className="seo-serp-preview border rounded p-2">
        <div
          className="seo-serp-preview__url small text-muted text-truncate"
          data-testid={`${testId}-url`}
        >
          {displayUrl}
        </div>
        <div
          className="seo-serp-preview__title text-primary"
          data-testid={`${testId}-title`}
        >
          {truncateForSerp(title ?? "", SERP_TITLE_LIMIT)}
        </div>
        <div
          className="text-muted"
          data-testid={`${testId}-description`}
        >
          {truncateForSerp(description ?? "", SERP_DESCRIPTION_LIMIT)}
        </div>
      </div>
    </div>
  );
}
